import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, CircularProgress } from "@mui/material";
import { getSorteos } from "../../../api/ApiService";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SorteosHeader from "./components/SorteosHeader";
import SorteosFiltrosComponents from "./components/SorteosFiltrosComponents";
import { VigenciaPromociones, VigenciaPublicaciones } from "../../../constantes/constantes";
import SorteosTableComponent from "./components/SorteosTableComponent";

export const statusOptions = [
    { label: 'Vigentes', value: "vigentes", id: 1 },
    { label: 'Inactivos', value: "inactivos", id: 2 },
    { label: 'Todos', value: "todos", id: 3 },
];

export const vigenciaPublicacionOptions = [...VigenciaPublicaciones];
export const vigenciaPromocionOptions = [...VigenciaPromociones];

function SorteosAppPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [nameCedula, setNameCedula] = useState('');

    const [vigenciaPublicacionSelected, setVigenciaPublicacionSelected] = useState(vigenciaPublicacionOptions.find((item) => item.value === "todos") || vigenciaPublicacionOptions[0]);

    const [vigenciaPromocionSelected, setVigenciaPromocionSelected] = useState(vigenciaPromocionOptions.find((item) => item.value === "todos") || vigenciaPromocionOptions[0]);

    const [loading, setLoading] = useState(false);
    const [dataSorteos, setDataSorteos] = useState([]);

    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);















    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();

    //cuando deje de escribir en el input, se ejecuta la busqueda despues de 2 segundos
    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (nameCedula.length > 2) {
                handleListarSorteosName(nameCedula);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, nameCedula]);

    useEffect(() => {
        if (stateToken) {
            handleListarSorteosInicial();
        }
    }, [stateToken]);

    //=============================================funcion para listar los sorteos
    const handleListarSorteosInicial = () => {
        let body = {
            page: 1,
            per_page: perPage,
            estado_publicacion: vigenciaPublicacionSelected?.value === undefined ? "" : vigenciaPublicacionSelected?.value,
            estado_promocion: vigenciaPromocionSelected?.value === undefined ? "" : vigenciaPromocionSelected?.value,
            titulo: nameCedula
        };

        setLoadingCargar(true);

        getSorteos(stateToken?.access_token, body)
            .then((response) => {
                console.log("response-getSorteos", response);
                setLoadingCargar(false);

                if (response.data.length > 0) {
                    setDataSorteos(response.data);
                    setLoading(true);
                } else {
                    setDataSorteos([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });
            })
            .catch((error) => {
                console.log("error-getSorteos", error);
                setDataSorteos([]);
                setLoading(true);
                setLoadingCargar(false);
            });
    };



    //=============================================funcion para listar los sorteos
    const handleListarSorteosName = (name) => {
        let body = {
            page: 1,
            per_page: perPage,
            estado_publicacion: vigenciaPublicacionSelected?.value === undefined ? "" : vigenciaPublicacionSelected?.value,
            estado_promocion: vigenciaPromocionSelected?.value === undefined ? "" : vigenciaPromocionSelected?.value,
            titulo: name
        };

        setLoadingCargar(true);
        getSorteos(stateToken?.access_token, body)
            .then((response) => {
                console.log("response-getSorteos", response?.data);
                setLoadingCargar(false);
                if (response.data.length > 0) {
                    setDataSorteos(response.data);
                    setLoading(true);
                } else {
                    setDataSorteos([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });
            })
            .catch((error) => {
                console.log("error-getSorteos", error);
                setLoadingCargar(false);
                setDataSorteos([]);
                setLoading(true);
            });
    };

    //=============================================funcion para listar los sorteos, cuando se selecciona la vigencia de la promocion
    const handleListarSorteosVigenciaPromocion = (promocion) => {
        let body = {
            page: 1,
            per_page: perPage,
            estado_publicacion: vigenciaPublicacionSelected?.value === undefined ? "" : vigenciaPublicacionSelected?.value,
            estado_promocion: promocion,
            titulo: nameCedula
        };
        setLoadingCargar(true);
        getSorteos(stateToken?.access_token, body)
            .then((response) => {
                console.log("response-getUsuarios", response?.data);
                setLoadingCargar(false);
                if (response.data.length > 0) {
                    setDataSorteos(response.data);
                    setLoading(true);
                } else {
                    setDataSorteos([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });
            })
            .catch((error) => {
                console.log("error-getSorteos", error);
                setLoadingCargar(false);
                setDataSorteos([]);
                setLoading(true);
            });
    };

    //=============================================funcion para listar los sorteos, cuando se selecciona la vigencia de la publicacion
    const handleListarSorteosVigenciaPublicacion = (publicacion) => {
        let body = {
            page: 1,
            per_page: perPage,
            estado_publicacion: publicacion,
            estado_promocion: vigenciaPromocionSelected?.value === undefined ? "" : vigenciaPromocionSelected?.value,
            titulo: nameCedula
        };

        setLoadingCargar(true);
        getSorteos(stateToken?.access_token, body)
            .then((response) => {
                console.log("response-getSorteos", response?.data);
                setLoadingCargar(false);
                if (response.data.length > 0) {
                    setDataSorteos(response.data);
                    setLoading(true);
                } else {
                    setDataSorteos([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });
            })
            .catch((error) => {
                console.log("error-getSorteos", error);
                setLoadingCargar(false);
                setDataSorteos([]);
                setLoading(true);
            });
    };


    //=============================================funcion para capturar el name y cedula
    const handleNameCedula = (e) => {
        setNameCedula(e);
    }


    //=============================================funcion para buscar la vigencia de la publicacion
    const handleVigenciaPublicacionSelected = (value) => {
        const optionSelected = vigenciaPublicacionOptions.find((option) => option.value === value);
        setVigenciaPublicacionSelected(optionSelected || null);

        if (value !== undefined) {
            setTimeout(() => {
                handleListarSorteosVigenciaPublicacion(value);
            }, 1000);
        }
    };


    //=========================================================funcion para seleccionar la vigencia de la promocion
    const handleVigenciaPromocionSelected = (value) => {
        const optionSelected = vigenciaPromocionOptions.find((option) => option.value === value);
        setVigenciaPromocionSelected(optionSelected || null);


        if (value !== undefined) {
            setTimeout(() => {
                handleListarSorteosVigenciaPromocion(value);
            }, 1000);
        }
    }








    const handleAddSorteo = () => {
        history('/app/admin/sorteos-agregar');
    };







    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEventos = (page = 1) => {

        let body = {
            page: page,
            per_page: perPage,
            estado_publicacion: vigenciaPublicacionSelected?.value === undefined ? "" : vigenciaPublicacionSelected?.value,
            estado_promocion: vigenciaPromocionSelected?.value === undefined ? "" : vigenciaPromocionSelected?.value,
            titulo: nameCedula
        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getSorteos(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarEventos", response);

                setLoadingCargar(false);

                if (response.data.length > 0) {
                    setDataSorteos(response.data);
                    setLoading(true);
                } else {
                    setDataSorteos([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getSorteos", error);
                setDataSorteos([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };




    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };

    const handleEditarItem = (item) => {
        // console.log("detalle a editar==>", item);

        history('/app/admin/sorteo-detalle/' + item?.id);

    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div className="mx-auto">
                        <SorteosHeader
                            title="Sorteos"
                            subtitle="Administra y supervisa los sorteos de la plataforma."
                            handleAdd={handleAddSorteo}
                        />

                        <div>
                            <SorteosFiltrosComponents
                                searchValue={nameCedula}
                                onSearchChange={handleNameCedula}
                                vigenciaPublicacionFilter={vigenciaPublicacionSelected?.value || "todos"}
                                onVigenciaPublicacionChange={handleVigenciaPublicacionSelected}
                                vigenciaPublicacionOptions={vigenciaPublicacionOptions}
                                vigenciaPromocionFilter={vigenciaPromocionSelected?.value || "todos"}
                                onVigenciaPromocionChange={handleVigenciaPromocionSelected}
                                vigenciaPromocionOptions={vigenciaPromocionOptions}
                            />

                            <SorteosTableComponent
                                data={dataSorteos}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarEventos}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditarItem}
                            // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />

                        </div>


                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default SorteosAppPage;